import { Input, InputGroup, InputLeftElement } from '@chakra-ui/react';
import * as React from 'react';

import { SearchIcon } from '@/imports/ui/chakra/feather';

type ILibrarySearchBarProps = {
  value: string;
  folderName: string;
  onTextChange: (searchText: string) => void;
  loading?: boolean;
};

export const LibrarySearchBar: React.FC<ILibrarySearchBarProps> = ({
  value,
  folderName,
  onTextChange,
  loading,
}) => {
  return (
    <InputGroup>
      <InputLeftElement pointerEvents="none">
        <SearchIcon color="gray.600" />
      </InputLeftElement>
      <Input
        value={value}
        variant="filled"
        borderRadius="full"
        placeholder={
          folderName ? `Search ${folderName}` : 'Search All Resources'
        }
        onChange={(e) => onTextChange(e.target.value)}
        type="search"
      />
    </InputGroup>
  );
};
